import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { CommonMedicineModel } from 'src/app/model/common/medicine';
import { CommonMedicineViewModel } from 'src/app/model/common/medicine.view';
import { commonAtcActions } from 'src/app/store/common/atc/atc.action';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonMedicineService extends BaseService {
  constructor(protected store: Store<any>, protected rest: RestService) {
    super();
  }

  getLoad = (): Observable<CommonMedicineViewModel[]> =>
    this.store.select('common', 'atc', 'medicines');

  readList = (
    atc: string,
    query: string = ''
  ): Observable<CommonMedicineViewModel[]> =>
    this.rest
      .get<CommonMedicineViewModel[]>({
        url: `${environment.endpoints.common}/medicine`,
        params: {
          atc,
          query,
        },
      })
      .pipe(
        tap((result) => {
          this.store.dispatch(
            commonAtcActions.setMedicineResultAction({ result })
          );
        })
      );

  createMedicine = (
    medicine: CommonMedicineModel
  ): Observable<CommonMedicineViewModel> =>
    this.rest
      .post<CommonMedicineViewModel>({
        url: `${environment.endpoints.common}/medicine`,
        body: medicine,
      })
      .pipe(
        tap((result) => {
          this.store.dispatch(commonAtcActions.addMedicineResultAction(result));
        })
      );
}
